import type { Anomaly, GetAnomaliesRequest, GetVehicleAnomaliesRequest, Tags, TagsRequest } from '../types/Anomaly';
import { api } from './api';
import type { PaginatedListResponse } from './response_models/PaginatedListIResponse';
// import type { GetAnomaliesStatsResponse } from "./response_models/anomalies/GetAnomaliesStatsResponse";

export const anomaliesApi = api.injectEndpoints({
  endpoints: builder => ({
    getAnomalies: builder.query<PaginatedListResponse<Anomaly>, GetAnomaliesRequest>({
      query: ({
        page,
        pageSize,
        searchText = '',
        risk_rating_min,
        risk_rating_max,
        sent_time_range_after,
        sent_time_range_before,
        anomaly_type,
        ordering,
      }) => {
        const params: any = {
          page,
          pageSize,
          search: searchText,
        };
        if (risk_rating_min !== undefined && risk_rating_max !== undefined) {
          params.risk_rating_min = risk_rating_min;
          params.risk_rating_max = risk_rating_max;
        }

        if (sent_time_range_after && sent_time_range_before) {
          params.sent_time_range_after = sent_time_range_after;
          params.sent_time_range_before = sent_time_range_before;
        }

        if (anomaly_type && anomaly_type != '') {
          params.anomaly_type = anomaly_type;
        }

        if (ordering) {
          params.ordering = ordering;
        }

        return {
          url: `anomalies/`,
          params: params,
        };
      },
    }),
    getAnomaly: builder.query<Anomaly, string>({
      query: id => ({
        url: `anomalies/${id}/`,
      }),
    }),
    headAnomalyClip: builder.query<boolean, string>({
      queryFn: async (url: string) => {
        let res = await fetch(`${url}`, { method: 'HEAD' });
        if (res.status === 404) return { data: false };
        return { data: true };
      },
    }),
    deleteAnomaly: builder.mutation<void, string>({
      query: id => ({
        url: `manage_anomalies/${id}/`,
        method: 'DELETE',
      }),
    }),
    getTags: builder.query<Tags[], void>({
      query: () => ({
        url: `tags/`,
      }),
    }),
    createTags: builder.mutation<boolean, TagsRequest>({
      query: data => ({
        url: `manage_tags/`,
        method: 'POST',
        body: data,
      }),
    }),
    deleteTags: builder.mutation<void, { anomaly_id: string; tag_id: number }>({
      query: ({ anomaly_id, tag_id }) => ({
        url: `tags_delete/${anomaly_id}/${tag_id}/`,
        method: 'DELETE',
      }),
    }),
    getVehicleAnomalies: builder.query<Anomaly[], GetVehicleAnomaliesRequest>({
      query: ({ vehicle_id, start_time, end_time }) => ({
        url: 'vehicle-anomalies/',
        params: {
          vehicle_id,
          start_time,
          end_time,
        },
      }),
    }),
    unArchiveAnomaly: builder.mutation<void, string>({
      query: id => ({
        url: `anomaly/${id}/restore/`,
        method: 'PUT',
      }),
    }),
    updateAnomaly: builder.mutation<
      void,
      { id: string; body: Partial<{ type: string; anomaly_type: string; needs_review: boolean }> }
    >({
      query: ({ id, body }) => ({
        url: `anomalies/${id}/update_anomaly/`,
        method: 'PATCH',
        body,
      }),
    }),
    getAnomalyProof: builder.query<{ url: string }, string>({
      query: id => ({
        url: `get_anomaly_proof/${id}/`,
      }),
    }),
  }),
});
//query of getanomaly
export const {
  // useLazyGetAnomaliesStatsQuery,
  useLazyGetAnomaliesQuery,
  useHeadAnomalyClipQuery,
  useDeleteAnomalyMutation,
  useLazyGetTagsQuery,
  useCreateTagsMutation,
  useDeleteTagsMutation,
  useLazyGetVehicleAnomaliesQuery,
  useGetAnomalyQuery,
  useUnArchiveAnomalyMutation,
  useUpdateAnomalyMutation,
  useLazyGetAnomalyProofQuery,
} = anomaliesApi;
